import { useDataStore } from '@/app/core/components/step-wizard';
import { useProgramWizardContext } from '@/app/core/components/program-wizard/program-wizard-context';
import { ProgramWizardMessage } from '@/app/core/components/program-wizard';
import { useEffect, useState } from 'react';
import { Alert } from '@ssar-app/uikit';
import { Box } from '@chakra-ui/react';

type DisplayWarningsProps = {
  messages: ProgramWizardMessage[];
};

export const DisplayWarnings = (props: DisplayWarningsProps) => {
  const { messages: _messages } = props;
  const { extractKeys: _extractKeys, data } = useDataStore();
  const {
    config: { isAutoSaveAllowed },
  } = useProgramWizardContext();

  const [showAutoSaveWarning, setShowAutoSaveWarning] = useState(false);

  useEffect(() => {
    if (isAutoSaveAllowed) {
      const proramName = data?.productInput?.productDetails?.programName || '';
      setShowAutoSaveWarning(!proramName || proramName.length < 3);
    }
  }, [data, isAutoSaveAllowed]);

  return (
    <>
      <Alert
        type='warning'
        isOpen
        showCloseButton={false}
        showIcon={false}
        title='Warnings:'
        description={
          <Box mx={3}>
            <ol>
              {showAutoSaveWarning && (
                <li>
                  Auto saving is paused. To continue auto saving this program,
                  please enter a valid program name.
                </li>
              )}
            </ol>
          </Box>
        }
      />
      <br />
    </>
  );
};
